// ink-component
import React from 'react';
import styled from 'styled-components';

import Controller from '../../../_common/Controller';

const NewFormSectionErrorElement = styled.p`
  margin-bottom: 8px;
`;

export interface NewFormSectionErrorProps extends React.HTMLAttributes<HTMLParagraphElement> {}

/**
 * @purpose Explains errors between multiple elements in this section
 * @categories form
 * @group NewFormSection
 * @position 3
 * @HTMLType HTMLParagraphElement
 */

function NewFormSectionError(props: NewFormSectionErrorProps) {
  const { children, style, className, ...otherProps } = props;
  return (
    <NewFormSectionErrorElement {...otherProps} aria-live="polite" aria-invalid="true">
      <Controller.Error>{children}</Controller.Error>
    </NewFormSectionErrorElement>
  );
}

NewFormSectionError.displayName = 'NewFormSection.Error';

export default NewFormSectionError;
